import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Custom hook to scroll page to the top on page change.
export const useScrollToTop = (): void => {
  const location = useLocation()

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'instant',
    })
  }, [location.pathname])
}
